@if (items && items.length > 0 && (size$ | async); as size) {
  @if (title) {
    <h2>{{ title }}</h2>
  }
  <div class="carousel-panel" [ngClass]="'size-' + size">
    @if (size < items.length) {
      <button
        class="previous"
        (click)="activeSlide = activeSlide - size"
        [disabled]="activeSlide === 0"
        [attr.aria-label]="'carousel.previousSlide' | cxTranslate"
        >
        <cx-icon [type]="previousIcon"></cx-icon>
      </button>
    }
    <div class="slides">
      @for (_ of items; track _; let i = $index) {
        @if (i % size === 0) {
          <div
            class="slide"
            [class.active]="i === activeSlide"
            >
            @for (item of items | slice: i:i + size; track item; let j = $index) {
              @if (item | async; as data) {
                <div
                  class="item"
                  [class.active]="i === activeSlide"
                  >
                  <ng-container
                    *ngTemplateOutlet="template; context: { item: data }"
                  ></ng-container>
                </div>
              }
            }
          </div>
        }
      }
    </div>
    @if (size < items.length) {
      <button
        class="next"
        (click)="activeSlide = activeSlide + size"
        tabindex="-1"
        [disabled]="activeSlide > items.length - size - 1"
        [attr.aria-label]="'carousel.nextSlide' | cxTranslate"
        >
        <cx-icon [type]="nextIcon"></cx-icon>
      </button>
    }
  </div>
  @if (!hideIndicators && size < items.length) {
    <div class="indicators">
      @for (_ of items; track _; let i = $index) {
        @if (i % size === 0) {
          <button
            (click)="activeSlide = i"
            [disabled]="i === activeSlide"
        [attr.aria-label]="
          'carousel.slideNumber'
            | cxTranslate: { currentSlideNumber: getSlideNumber(size, i) }
        "
            tabindex="-1"
            >
            <cx-icon [type]="indicatorIcon" aria-hidden="true"></cx-icon>
          </button>
        }
      }
    </div>
  }
}
